import { hDeepCopy } from '@/utils/helpers';
import moment from 'moment';
import ShAgentAvatar from '@/components/Helpers/ShAgentAvatar';
import ShProgressBar from '@/components/Helpers/ShProgressBar';
import ForwardCallPopover from '../../ForwardCallPopover';
import TimeCounter from '@/components/AgentActions/TimeCounter';

// @vue/component
export default {
  name: 'DashboardListItem',

  components: {
    ShAgentAvatar,
    ShProgressBar,
    ForwardCallPopover,
    TimeCounter,
  },
  props: {
    agent: {
      type: Object,
      default: () => ({}),
    },
    isStatusChangeButtonShowed: {
      type: Boolean,
      default: false,
    },
    isStatusChangeButtonDisabled: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: '',
    },
    agentStatusList: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isStatusLoading: false,
      timeLeftForBreak: '0',
      timestampForBreak: '0',
    };
  },
  computed: {
    maxAgentBreakTime() {
      // time is in minutes, and should be in seconds
      return this.agent.pause_long_time * 60;
    },
    agentStatus() {
      let timePauseFormatted = '';
      let timeDnDFormatted = '';
      let timeLoggedFormatted = '';
      if(this.agent.time_dnd_change){
        timeDnDFormatted = ' OD '+moment(this.agent.time_dnd_change).format('YYYY-MM-DD HH:mm:ss');
      }
      if(this.agent.time_pause_change){
        timePauseFormatted = ` OD ${moment(this.agent.time_pause_change).format('YYYY-MM-DD HH:mm:ss')}, pozostało `;
      }
      if(this.agent.time_logged_change){
        timeLoggedFormatted = ' OD '+moment(this.agent.time_logged_change).format('YYYY-MM-DD HH:mm:ss');
      }
      if (this.agent.is_talking) return 'OBSŁUGUJE POŁĄCZENIE';
      if (this.agent.is_dnd) return 'DND'+timeDnDFormatted;
      if (this.agent.is_paused) return 'PRZERWA'+timePauseFormatted;
      if (this.agent.is_logged) return 'ZALOGOWANY'+timeLoggedFormatted;
      return 'NIEZALOGOWANY'+timeLoggedFormatted;
    },
    agentsBelongsToUserList() {
      return hDeepCopy(this.$store.getters['user/agent/agentsBelongsToUserlist'].records);
    },
  },
  watch: {
    agent: {
      handler(newVal) {
        if (newVal.is_paused) {
          this.setTimeLeftForBreak(newVal);
        }
      },
    },
    deep: true,
  },
  created() {
    if (this.agent.is_paused) {
      this.setTimeLeftForBreak(this.agent);
    }
  },
  methods: {
    isAgentBelongsToUser() {
      return this.agentsBelongsToUserList.some(agent => agent.uuid === this.agent.uuid);
    },
    getLighterColor(colorValue) {
      const color = require('color');
      return color(colorValue).lighten(0.55);
    },
    getDarkenColor(colorValue) {
      const color = require('color');
      return color(colorValue).darken(0.3);
    },
    setTimeLeftForBreak(agent) {
      let nowTimestamp = moment();
      let startedBreakTimestamp = moment(agent.time_pause_change);
      this.timestampForBreak = moment(agent.time_pause_change).add(this.maxAgentBreakTime, 'seconds').format('YYYY-MM-DD HH:mm:ss');
      this.timeLeftForBreak = nowTimestamp.diff(startedBreakTimestamp, 'seconds');
    },
    async toggleAgentStatus(agentUuid, status) {
      let params = {
        agent: agentUuid,
        status: !status,
        action_id: 1,
      };
      this.isStatusLoading = true;
      await this.$store.dispatch('user/agent/setStatus', params);
      await this.$emit('fetchAgents');
      this.isStatusLoading = false;
    },
    async toggleAgentBreakStatus(agentUuid, status, actionId) {
      if (Number(actionId) === Number(3) && status) {
        this.$refs.timeCounter.stopCounting();
        this.timeLeftForBreak = 0;
      }
      let params = {
        agent: agentUuid,
        status: !status,
        action_id: actionId,
      };
      await this.$store.dispatch('user/agent/setStatus', params);
      this.getAgentList();
    },
    getAgentList() {
      this.$store.dispatch('user/agent/getAgentsBelongsToUserList', this.userUuid);
    },
  },
};
